import routes from "../../routes";

export const supportEmail = "support@geneious.com";

export const list1 = [
	{
		text: "LIST_1.ITEM_1.TEXT",
		subList: [
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_1" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_2" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_3" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_4" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_5" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_6" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_7" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_8" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_9" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_10" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_11" },
			{ text: "LIST_1.ITEM_1.SUB_LIST.ITEM_12" },
		],
	},
	{
		text: "LIST_1.ITEM_2.TEXT",
		subList: [
			{ text: "LIST_1.ITEM_2.SUB_LIST.ITEM_1" },
			{ text: "LIST_1.ITEM_2.SUB_LIST.ITEM_2" },
			{ text: "LIST_1.ITEM_2.SUB_LIST.ITEM_3" },
		],
	},
	{
		text: "LIST_1.ITEM_3.TEXT",
		subList: [
			{ text: "LIST_1.ITEM_3.SUB_LIST.ITEM_1" },
			{ text: "LIST_1.ITEM_3.SUB_LIST.ITEM_2" },
			{ text: "LIST_1.ITEM_3.SUB_LIST.ITEM_3" },
			{
				text: "LIST_1.ITEM_3.SUB_LIST.ITEM_4.TEXT",
				subList: [
					{ text: "LIST_1.ITEM_3.SUB_LIST.ITEM_4.SUB_LIST.ITEM_1" },
					{ text: "LIST_1.ITEM_3.SUB_LIST.ITEM_4.SUB_LIST.ITEM_2" },
					{ text: "LIST_1.ITEM_3.SUB_LIST.ITEM_4.SUB_LIST.ITEM_3" },
				],
			},
		],
	},
	{
		text: "LIST_1.ITEM_4.TEXT",
		subList: [
			{ text: "LIST_1.ITEM_4.SUB_LIST.ITEM_1" },
			{ text: "LIST_1.ITEM_4.SUB_LIST.ITEM_2" },
			{ text: "LIST_1.ITEM_4.SUB_LIST.ITEM_3" },
		],
	},
	{
		text: "LIST_1.ITEM_5.TEXT",
		subList: [
			{
				text: "LIST_1.ITEM_5.SUB_LIST.ITEM_1.TEXT",
				subList: [
					{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_1.SUB_LIST.ITEM_1" },
					{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_1.SUB_LIST.ITEM_2" },
					{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_1.SUB_LIST.ITEM_3" },
				],
			},
			{
				text: "LIST_1.ITEM_5.SUB_LIST.ITEM_2.TEXT",
				subList: [
					{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_2.SUB_LIST.ITEM_1" },
					{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_2.SUB_LIST.ITEM_2" },
				],
			},
			{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_3" },
			{ text: "LIST_1.ITEM_5.SUB_LIST.ITEM_4" },
		],
	},
	{
		text: "LIST_1.ITEM_6.TEXT",
		subList: [
			{
				text: "LIST_1.ITEM_6.SUB_LIST.ITEM_1",
				helpGeneious: routes.external.helpGeneious,
				supportEmail,
			},
			{ text: "LIST_1.ITEM_6.SUB_LIST.ITEM_2" },
			{ text: "LIST_1.ITEM_6.SUB_LIST.ITEM_3" },
		],
	},
	{
		text: "LIST_1.ITEM_7.TEXT",
		subList: [{ text: "LIST_1.ITEM_7.SUB_LIST.ITEM_1" }, { text: "LIST_1.ITEM_7.SUB_LIST.ITEM_2" }],
	},
	{ text: "LIST_1.ITEM_8.TEXT" },
	{ text: "LIST_1.ITEM_9.TEXT" },
	{ text: "LIST_1.ITEM_10.TEXT" },
	{
		text: "LIST_1.ITEM_11.TEXT",
		subList: [
			{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_1" },
			{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_2" },
			{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_3" },
			{
				text: "LIST_1.ITEM_11.SUB_LIST.ITEM_4.TEXT",
				subList: [
					{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_4.SUB_LIST.ITEM_1" },
					{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_4.SUB_LIST.ITEM_2" },
					{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_4.SUB_LIST.ITEM_3" },
				],
			},
			{ text: "LIST_1.ITEM_11.SUB_LIST.ITEM_5" },
		],
	},
	{
		text: "LIST_1.ITEM_12.TEXT",
		subList: [
			{ text: "LIST_1.ITEM_12.SUB_LIST.ITEM_1" },
			{ text: "LIST_1.ITEM_12.SUB_LIST.ITEM_2" },
		],
	},
	{ text: "LIST_1.ITEM_13.TEXT" },
	{ text: "LIST_1.ITEM_14.TEXT" },
	{ text: "LIST_1.ITEM_15.TEXT" },
	{ text: "LIST_1.ITEM_16.TEXT" },
	{ text: "LIST_1.ITEM_17.TEXT" },
	{ text: "LIST_1.ITEM_18.TEXT" },
	{ text: "LIST_1.ITEM_19.TEXT" },
	{ text: "LIST_1.ITEM_20.TEXT" },
	{ text: "LIST_1.ITEM_21.TEXT" },
	{ text: "LIST_1.ITEM_22.TEXT" },
	{ text: "LIST_1.ITEM_23.TEXT" },
	{ text: "LIST_1.ITEM_24.TEXT" },
	{ text: "LIST_1.ITEM_25.TEXT" },
	{ text: "LIST_1.ITEM_26.TEXT" },
	{ text: "LIST_1.ITEM_27.TEXT" },
	{ text: "LIST_1.ITEM_28.TEXT" },
];

export const list2 = [
	{
		text: "LIST_2.ITEM_1.TEXT",
		subList: [
			{ text: "LIST_2.ITEM_1.SUB_LIST.ITEM_1" },
			{ text: "LIST_2.ITEM_1.SUB_LIST.ITEM_2" },
			{ text: "LIST_2.ITEM_1.SUB_LIST.ITEM_3" },
		],
	},
	{
		text: "LIST_2.ITEM_2.TEXT",
		subList: [
			{ text: "LIST_2.ITEM_2.SUB_LIST.ITEM_1" },
			{ text: "LIST_2.ITEM_2.SUB_LIST.ITEM_2" },
			{ text: "LIST_2.ITEM_2.SUB_LIST.ITEM_3" },
		],
	},
	{
		text: "LIST_2.ITEM_3.TEXT",
		subList: [
			{ text: "LIST_2.ITEM_3.SUB_LIST.ITEM_1" },
			{ text: "LIST_2.ITEM_3.SUB_LIST.ITEM_2" },
			{ text: "LIST_2.ITEM_3.SUB_LIST.ITEM_3" },
			{ text: "LIST_2.ITEM_3.SUB_LIST.ITEM_4" },
		],
	},
	{ text: "LIST_2.ITEM_4.TEXT" },
	{ text: "LIST_2.ITEM_5.TEXT" },
	{
		text: "LIST_2.ITEM_6.TEXT",
		subList: [
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_1" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_2" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_3" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_4" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_5" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_6" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_7" },
			{ text: "LIST_2.ITEM_6.SUB_LIST.ITEM_8" },
		],
	},
	{ text: "LIST_2.ITEM_7.TEXT" },
	{ text: "LIST_2.ITEM_8.TEXT" },
];

export const list3 = [
	{
		text: "LIST_3.ITEM_1.TEXT",
		subList: [
			{ text: "LIST_3.ITEM_1.SUB_LIST.ITEM_1" },
			{ text: "LIST_3.ITEM_1.SUB_LIST.ITEM_2" },
			{ text: "LIST_3.ITEM_1.SUB_LIST.ITEM_3" },
		],
	},
	{
		text: "LIST_3.ITEM_2.TEXT",
		subList: [
			{ text: "LIST_3.ITEM_2.SUB_LIST.ITEM_1" },
			{ text: "LIST_3.ITEM_2.SUB_LIST.ITEM_2" },
			{ text: "LIST_3.ITEM_2.SUB_LIST.ITEM_3" },
		],
	},
	{ text: "LIST_3.ITEM_3.TEXT" },
	{
		text: "LIST_3.ITEM_4.TEXT",
		subList: [{ text: "LIST_3.ITEM_4.SUB_LIST.ITEM_1" }, { text: "LIST_3.ITEM_4.SUB_LIST.ITEM_2" }],
	},
	{ text: "LIST_3.ITEM_5.TEXT" },
	{ text: "LIST_3.ITEM_6.TEXT", dotmaticsPrivacyPolicy: routes.external.privacyPolicy },
];
